import { useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import { getProjectProgressionStatus } from 'common/services/project-progression.service';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';

const useStatus = () => {
  const pmSensorAuthId = usePmSensorAuthId();
  const [status, setStatus] = useState(null);

  const fetchStatus = useDebounceCallback(async () => {
    try {
      const res = await getProjectProgressionStatus({
        sensor_authorization_id: pmSensorAuthId
      });
      setStatus(res);
    } catch (e) {
      setStatus(null);
    }
  }, 200);

  useEffect(() => {
    fetchStatus();
  }, []);

  return status;
};

export default useStatus;
